import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import WP from "WP";
import api from "api";
import modules from "modules";
import { setImageGallery, setCurrentView } from "store";
import useIsMobile from "hooks/useIsMobile";

import BookingInfo from "./BookingInfo";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Overlay from "partials/Overlay";
import ErrorBoundary from "partials/ErrorBoundary";
import Footer from "partials/Footer";
import CookieNotice from "partials/CookieNotice";

import Media from "css/Media";

export const RestaurantPage = (props) => {
  const isMobile = useIsMobile();
  const [loading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  //fetch page on mount
  useEffect(() => {
    preparePage();
  }, []);

  //fetch page again if slug updates
  useEffect(() => {
    preparePage();
  }, [props.match.params.slug]);

  const preparePage = () => {
    window.scrollTo(0, 0);
    api.diningFetcher.getAll().then(() => {
      api.diningFetcher
        .getBySlug({ slug: props.match.params.slug })
        .then((r) => {
          if (!r.data.length) {
            console.log(
              "error fetching dining page by slug: ",
              props.match.params.slug
            );
            return;
          } else {
            let page = r.data[0];
            props.setCurrentView(page);
            setData(page);
            setIsLoading(false);
            scrapeForImages();
          }
        });
    });
  };

  const scrapeForImages = () => {
    if (data && data.acf && data.acf.modules) {
      let arr = [];

      let twoImagesArr = data.acf.modules.filter(
        (module) => module.acf_fc_layout === "two_images"
      );
      if (twoImagesArr.length) {
        twoImagesArr.map((module) => {
          arr = [
            ...arr,
            { image: module.image_one },
            { image: module.image_two },
          ];
          return null;
        });
      }

      let imageModuleArr = data.acf.modules.filter(
        (module) => module.acf_fc_layout === "image"
      );
      if (imageModuleArr.length) {
        imageModuleArr.map((module) => {
          arr = [...arr, { image: module.image }];
          return null;
        });
      }
      props.setImageGallery(arr);
    }
  };

  if (!data || (data && loading)) return null;
  return (
    <Wrapper>
      <Container grid>
        <GridElement
          colStart={{ default: 1, s: 7 }}
          colEnd={{ default: 8, s: 18 }}
        >
          <h2>{data.acf.title}</h2>
          <h5>{data.acf.description}</h5>
        </GridElement>
      </Container>
      <BookingInfo
        data={data}
        src={data.acf.src}
        phone={data.acf.phone}
        link={data.acf.web_page_url}
        isMobile={isMobile}
      />
      <Modules>
        <ErrorBoundary for='Dining Builder'>
          {data &&
            data.acf.modules &&
            data.acf.modules.map((module, i) => {
              return (
                <div key={i} className={"module-" + module.acf_fc_layout}>
                  {React.createElement(modules[module.acf_fc_layout], {
                    data: module,
                  })}
                </div>
              );
            })}
        </ErrorBoundary>
      </Modules>
      <Overlay />
      <ErrorBoundary for='Footer'>
        <Footer />
      </ErrorBoundary>
      <CookieNotice />
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  dining: state.dining.posts[WP.lang] ? state.dining.posts[WP.lang] : [],
  page: state.currentView,
});

const actions = {
  setImageGallery,
  setCurrentView,
};

export default connect(mapStateToProps, actions)(withRouter(RestaurantPage));

const Wrapper = styled.section`
  scroll-behavior: smooth;
  width: 100%;
  padding-top: 120px;

  .container {
    h2 {
      margin-bottom: ${(props) => props.theme.spacing.contentXL};
    }
    h5 {
      margin-bottom: ${(props) => props.theme.spacing.contentL};
    }

    ${Media.greaterThan("s")`
      h2 {
        margin-bottom: ${(props) => props.theme.spacing.elementS};
      }
      h5 {
        margin-bottom: ${(props) => props.theme.spacing.elementS};
      }
    `}
  }

  ${Media.greaterThan("s")`
    padding-top: 220px;
  `}
`;

const Modules = styled.section`
  padding-bottom: ${(props) => props.theme.spacing.blockS};

  ${Media.greaterThan("s")`
    padding-bottom: ${(props) => props.theme.spacing.blockXL};
  `}
`;
